import Base from './Base'

/**
 * 用户相关服务
 */
export default class User extends Base {
  // 通知列表
  static getNoticeAll() {
    return super.get('notice/systemNotify.json?notice=1&stop=1')
  }

  // 通知详情
  static getNoticeDetail(id) {
    return super.get('notice/selectById.json', { id })
  }

  // 代办事项
  static getTasks() {
    return super.get('common/allOrder/tasks.json')
  }
  // home页面广告数据
  static getBannerList(position) {
    return super.get(`/platform/configAd/list.json?position=${position}`)
  }

  // 用户C端注册
  static addCustomer(params) {
    return super.get(`pss/customer/add.json`, params)
  }

  // 首页获取用户待办事项卡片QA
  static getActionList(params) {
    return super.get(`/message/quick/action/list.json`, params)
  }

  // 首页获取用户待办事项类型
  static getActionTypeList() {
    return super.get(`/message/quick/action/type/list.json`)
  }

  static getActionToDo(url) {
    return super.get(url)
  }
}
